import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "../redux/reducers";
import thunk from "redux-thunk";
import { saveState, loadState } from "../utils/localStorage";
import throttle from "lodash/throttle";

const persistedState = loadState();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  rootReducer,
  persistedState,
  composeEnhancers(applyMiddleware(thunk))
);


store.subscribe(
  throttle(() => {
    saveState(
      store.getState()
    );
  }, 1)
);
